module.exports = __webpack_public_path__ + "7c46159516da70d82e85ae99eacca816.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-1080.jpg
// module id = 407
// module chunks = 0